/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadReportingFrameworks } from '../../actions/reportingFrameworks';
import Loader from '../../components/loader';
import { ROUTES } from '../../constants/routes';
import { RootState } from '../../reducers';
import SDGAP from './SDGAP';

const Taxonomy = () => {

  const dispatch = useDispatch();
  const frameworks = useSelector((state: RootState) => state.reportingFrameworks);

  React.useEffect(() => {
    dispatch(loadReportingFrameworks());
  }, [dispatch]);

  if (!frameworks.loaded || frameworks.reportType !== 'taxonomy') {
    return <Loader />
  }

  return <SDGAP route={ROUTES.SDGAP} />;
}

export default Taxonomy;
